export type InstallPlatform = 'installed' | 'ios' | 'android' | 'other'

export type Device = {
  userAgent: string
  maxTouchPoints: number
  /** Running from the home screen rather than in a browser tab. */
  standalone: boolean
}

/** Which installation steps apply to this device. */
export function installPlatform({
  userAgent,
  maxTouchPoints,
  standalone,
}: Device): InstallPlatform {
  if (standalone) return 'installed'
  // iPadOS reports itself as a Mac: only the touch screen tells them apart
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1))
    return 'ios'
  if (/Android/.test(userAgent)) return 'android'
  return 'other'
}
